export default {
  'da': {
    'heading': 'Kontakt os nu',
    'sub_heading': 'Lad os lave noget fantastisk',
    'contact': '<h5><strong>Ring til os på <a href=\'tel:+4566118311\'>(+45) 6611 8311</a> eller send en e-mail til <a href=\'mailto:info@onlinecity.io\'>info@onlinecity.io</a><strong></h5>',
    'ods_header': '<strong>Odense</strong><br />kontor',
    'ods_address': '<p><strong>Buchwaldsgade 50</strong></p><p>5000 Odense C</p><p>Danmark</p>',
    'cph_header': '<strong>København</strong><br />kontor',
    'cph_address': '<p><strong>Danneskiold-Samsøes Allé 41</strong></p><p>1434 København K</p><p>Danmark</p>',
    'aal_header': '<strong>Aalborg</strong><br />kontor',
    'aal_address': '<p><strong>C. A. Olesens gade 4</strong></p><p>9000 Aalborg</p><p>Danmark</p>',
    'bi_header': '<strong>Virksomheds-</strong><br />oplysninger',
    'de_header': '<strong>München</strong><br />kontor',
    'de_address': '<p><strong>Landsberger Str. 314,</strong></p><p>80687 München</p><p>Tyskland</p>',
    'business_info': [
      {
        'title': 'ONLINECITY.IO ApS CVR:',
        'value': '27364276'
      }, {
        'title': 'Bank information:',
        'value': 'Sydbank - 6845 0001357732'
      }, {
        'title': 'Revisor:',
        'value': 'Ernst & Young (EY)'
      }, {
        'title': 'Advokat:',
        'value': 'Kielberg advokater A/S'
      }
    ]
  },
  'en': {
    'heading': 'Get in touch',
    'sub_heading': 'Let\'s do something fantastic',
    'contact': '<h5><strong>Call us on <a href=\'tel:+4566118311\'>(+45) 6611 8311</a> or send an e-mail to <a href=\'mailto:info@onlinecity.io\'>info@onlinecity.io</a></strong></h5>',
    'ods_header': '<strong>Odense</strong><br />office',
    'ods_address': '<p><strong>Buchwaldsgade 50</strong></p><p>5000 Odense C</p><p>Denmark</p>',
    'cph_header': '<strong>Copenhagen</strong><br />office',
    'cph_address': '<p><strong>Danneskiold-Samsøes Allé 41</strong></p><p>1434 København K</p><p>Denmark</p>',
    'aal_header': '<strong>Aalborg</strong><br />office',
    'aal_address': '<p><strong>C. A. Olesens gade 4</strong></p><p>9000 Aalborg</p><p>Denmark</p>',
    'de_header': '<strong>Munich</strong><br />office',
    'de_address': '<p><strong>Landsberger Str. 314,</strong></p><p>80687 Munich</p><p>Germany</p>',
    'bi_header': '<strong>Business</strong><br />info',
    'business_info': [
      {
        'title': 'ONLINECITY.IO ApS CVR:',
        'value': '27364276'
      }, {
        'title': 'Bank information:',
        'value': 'Sydbank - 6845 0001357732'
      }, {
        'title': 'Accountant:',
        'value': 'Ernst & Young (EY)'
      }, {
        'title': 'Lawyer:',
        'value': 'Kielberg advokater A/S'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/multilanguage/footer.js